var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#admin_svg__clip0_1370_827)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.124 1.854c-.496 0-.875.37-.875.857a.78.78 0 00.26.603L9.883 5.94 7.406 1.6A.841.841 0 007.84.857C7.84.371 7.461 0 6.965 0c-.497 0-.876.37-.876.857 0 .317.174.603.434.742L4.046 5.94 1.428 3.314c.236-.14.323-.37.323-.603 0-.486-.379-.857-.876-.857-.496 0-.875.37-.875.857s.379.858.875.858h.056L1.396 9.4h11.208l.465-5.832h.055c.497 0 .876-.371.876-.858a.87.87 0 00-.876-.857zM1.72 11h10.562a.321.321 0 00.323-.317v-.772h-11.2v.772c0 .201.142.317.323.317H1.72z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "admin_svg__clip0_1370_827"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v11H0z"
  })))));
}
export default SvgAdmin;